import type { Directive, DirectiveBinding } from 'vue'

// Extend the HTMLElement type to include our _observer property
declare global {
  interface HTMLElement {
    _observer?: IntersectionObserver;
  }
}

export const lazyLoad: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries
      if (entry.isIntersecting) {
        if (binding.value) {
          binding.value()
        }
        observer.unobserve(el)
      }
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    })

    observer.observe(el)

    // Store the observer on the element to access it for cleanup
    el._observer = observer
  },

  // Handle component updates
  updated(el: HTMLElement, binding: DirectiveBinding) {
    // If the binding value has changed, we might need to re-observe
    if (el._observer && binding.oldValue !== binding.value) {
      el._observer.observe(el)
    }
  },

  // Cleanup when component is unmounted
  unmounted(el: HTMLElement) {
    if (el._observer) {
      el._observer.disconnect()
      delete el._observer
    }
  }
}
